/* Styles are applied when style chunk is built */
import {withStyles} from '@/hocs/withStyles';
import {withNormalWeight, withBoldWeight} from '@/hocs/withFontType';

const PlainTh = props => <th {...props} />;
const PlainTr = props => <tr {...props} />;
const PlainTd = props => <td {...props} />;
const TBody = props => <tbody {...props} />;
const Table = props => <table {...props} />;
const TH = withStyles(PlainTh, 'th');
const TR = withBoldWeight(withStyles(PlainTr, 'tr'));
const TD = withNormalWeight(withStyles(PlainTd, 'td'));

export {Table, TBody, TH, TR, TD};
